export const normalizeSupplier = supplier => {
  if (!supplier) return null;

  const vendorNumRaw =
    supplier.VendorNum ??
    supplier.vendorNum ??
    supplier.VendorID ??
    supplier.vendorID ??
    supplier.SupplierNumber ??
    supplier.SupplierID ??
    supplier.value ??
    supplier.id ??
    null;

  if (vendorNumRaw === null || typeof vendorNumRaw === 'undefined' || vendorNumRaw === '') {
    return null;
  }

  const vendorNameRaw =
    supplier.VendorName ??
    supplier.vendorName ??
    supplier.SupplierName ??
    supplier.label ??
    supplier.name ??
    supplier.Description ??
    supplier.title ??
    '';

  const vendorNum = String(vendorNumRaw).trim();
  const vendorName = vendorNameRaw ? String(vendorNameRaw).trim() : vendorNum;

  if (!vendorNum) return null;

  return {
    VendorNum: vendorNum,
    VendorName: vendorName
  };
};

export const mergeSupplierLists = (existing = [], incoming = [], options = {}) => {
  const {preferIncoming = false} = options;
  const map = new Map();

  const addToMap = (supplier, shouldOverride = true) => {
    const normalized = normalizeSupplier(supplier);
    if (!normalized) return;

    if (!map.has(normalized.VendorNum) || shouldOverride) {
      map.set(normalized.VendorNum, normalized);
    }
  };

  (existing || []).forEach(existingSupplier => addToMap(existingSupplier, false));
  (incoming || []).forEach(newSupplier => addToMap(newSupplier, preferIncoming));

  return Array.from(map.values()).sort((a, b) =>
    a.VendorName.localeCompare(b.VendorName, undefined, {sensitivity: 'base'})
  );
};

